import { MatDialogConfig } from '@angular/material/dialog';

export const KPI_DETAILS_DIALOG_PANEL_CLASS = 'kpi-details-dialog-panel';

export function createKpiDetailsDialogConfig<T>(data: T, overrides: MatDialogConfig = {}): MatDialogConfig<T> {
  return {
    width: '800px',
    panelClass: KPI_DETAILS_DIALOG_PANEL_CLASS,
    autoFocus: false,
    ...overrides,
    data,
  };
}
